// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sv_p","placeholdersHeader":"styles_placeholdersHeader__3_h73","editorStyle":"styles_editorStyle__2Ef0f","placeholdersBox":"styles_placeholdersBox__2SYnA"};